import {
  EmptyState,
  EmptyStateType,
  SideModal,
  Tabs,
  Text,
} from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import { CardMaintenance } from '../CardMaintenance/CardMaintenance';
import { MessageMaintenance } from '../MessageMaintenance/MessageMaintenance';
import styles from './BankMaintenanceSideModal.module.css';
import { useBankMaintenanceSideModal } from './useBankMaintenanceSideModal';

type BankMaintainanceSideModalProps = {
  source: string;
  show: boolean;
  handleToggleSideModal: () => void;
};

export const BankMaintenanceSideModal = ({
  source,
  show,
  handleToggleSideModal,
}: BankMaintainanceSideModalProps) => {
  const { getTranslation } = useTranslate();
  const { activeTab, onChangeTab } = Tabs.useTabs();
  const { orderAdhocData, orderDailyData, getBankName } =
    useBankMaintenanceSideModal(activeTab, source);
  return (
    <SideModal
      show={show}
      onClose={() => {
        handleToggleSideModal();
      }}
    >
      <SideModal.Header>
        <Text textStyle={Text.Style.BodyLgSemibold}>
          {getTranslation('common_bankMaintenanceSchedule')}
        </Text>
      </SideModal.Header>
      <SideModal.Body>
        <div className={styles.tabHeader}>
          <Tabs activeIndex={activeTab} onChange={onChangeTab}>
            <Tabs.Tab
              label={getTranslation('notifications_bankMaintenance_type_EOD')}
            />
            <Tabs.Tab label={getTranslation('common_more')} />
          </Tabs>
        </div>
        <Tabs.Panel activeIndex={activeTab} index={0}>
          {orderDailyData && orderDailyData.length > 0 ? (
            <div className={styles.content}>
              <MessageMaintenance />
              {orderDailyData.map((item, index) => (
                <>
                  <br />
                  <CardMaintenance
                    key={`daily-maintenance-${index}`}
                    type="DAILY"
                    icon={item.recipient_bank_code}
                    bankName={
                      getBankName(item.recipient_bank_code as string) ||
                      item.recipient_bank_code
                    }
                    schedules={item.schedules}
                    isMaintenance={item.isMaintenance}
                  />
                </>
              ))}
            </div>
          ) : (
            <EmptyState
              type={EmptyStateType.SIMPLE_CUSTOM_IMAGE}
              imageName="emptyState_scheduleMaintenanceBank"
              stylesImage={{
                width: '230px',
              }}
              title={getTranslation('bankMaintenance_adhoc_emptyState_title')}
              headerProps={{
                textStyle: Text.Style.HeadingSm,
              }}
              detail={getTranslation(
                'bankMaintenance_adhoc_emptyState_description',
              )}
              descriptionProps={{
                textStyle: Text.Style.BodySmRegular,
              }}
            />
          )}
        </Tabs.Panel>
        <Tabs.Panel activeIndex={activeTab} index={1}>
          {orderAdhocData && orderAdhocData.length > 0 ? (
            <div className={styles.content}>
              <MessageMaintenance />
              {orderAdhocData.map((item, index) => (
                <>
                  <br />
                  <CardMaintenance
                    type="ADHOC"
                    key={`other-maintenance-${index}`}
                    icon={item.recipient_bank_code}
                    bankName={
                      getBankName(item.recipient_bank_code as string) ||
                      undefined
                    }
                    times={item.schedules}
                    isMaintenance={item.isMaintenance}
                  />
                </>
              ))}
            </div>
          ) : (
            <EmptyState
              type={EmptyStateType.SIMPLE_CUSTOM_IMAGE}
              imageName="emptyState_scheduleMaintenanceBank"
              stylesImage={{
                width: '230px',
              }}
              title={getTranslation('bankMaintenance_adhoc_emptyState_title')}
              headerProps={{
                textStyle: Text.Style.HeadingSm,
              }}
              detail={getTranslation(
                'bankMaintenance_adhoc_emptyState_description',
              )}
              descriptionProps={{
                textStyle: Text.Style.BodySmRegular,
              }}
            />
          )}
        </Tabs.Panel>
      </SideModal.Body>
    </SideModal>
  );
};
